// Route search params, kept apart from the page (2026-10-31): the route file's validateSearch is not code-split, so
// whatever it imports ships in the first-load entry chunk. This file must stay free of React, UI and messages.
export const PRESETS = ["7d", "30d", "90d", "12m", "mtd", "last-month", "ytd"] as const;
export type Preset = (typeof PRESETS)[number];
